module.exports = __webpack_public_path__ + "img/240x82_button_performance@2x.ebeb86d9.png";